// extracted by mini-css-extract-plugin
export default {"imageContainer":"K6-z","summaryPar":"L6-z","ratingCategories":"M6-z","reviewerInfo":"N6-z","reviewTypes":"O6-z","expanded":"P6-z"};